import { createSlice } from "@reduxjs/toolkit";

const accountSlice = createSlice({
    name: 'account',
    initialState: {
        loading: false,
        categories: { income: [], expense: [] },
        day: null,
        monthly: null,
        byCategory: [],
        categoryEntries: [],
        isEntryAdded: false,
        isEntryDeleted: false,
        isOpeningSet: false
    },
    reducers: {
        accountRequest(state) {
            return { ...state, loading: true };
        },
        categoriesSuccess(state, action) {
            return { ...state, loading: false, categories: { income: action.payload.income, expense: action.payload.expense } };
        },
        daySummarySuccess(state, action) {
            return { ...state, loading: false, day: action.payload };
        },
        monthlySummarySuccess(state, action) {
            return { ...state, loading: false, monthly: action.payload };
        },
        categorySummarySuccess(state, action) {
            return { ...state, loading: false, byCategory: action.payload.categories, categoryEntries: action.payload.entries };
        },
        entryAddedSuccess(state) {
            return { ...state, loading: false, isEntryAdded: true };
        },
        clearEntryAdded(state) {
            return { ...state, isEntryAdded: false };
        },
        entryDeletedSuccess(state) {
            return { ...state, loading: false, isEntryDeleted: true };
        },
        clearEntryDeleted(state) {
            return { ...state, isEntryDeleted: false };
        },
        openingSetSuccess(state) {
            return { ...state, loading: false, isOpeningSet: true };
        },
        clearOpeningSet(state) {
            return { ...state, isOpeningSet: false };
        },
        accountFail(state, action) {
            return { ...state, loading: false, error: action.payload };
        },
        clearAccountError(state) {
            return { ...state, error: null };
        }
    }
});

const { actions, reducer } = accountSlice;

export const {
    accountRequest,
    categoriesSuccess,
    daySummarySuccess,
    monthlySummarySuccess,
    categorySummarySuccess,
    entryAddedSuccess,
    clearEntryAdded,
    entryDeletedSuccess,
    clearEntryDeleted,
    openingSetSuccess,
    clearOpeningSet,
    accountFail,
    clearAccountError
} = actions;

export default reducer;
